import { chirpGateways, createChirpFetch, loadBalancers } from 'chirp-fetch';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { useGetUserInsightsQuery } from '../../../__generated__/chirp/com/hubspot/marketplace/insights/rpc/UserInsightsChirpService.hooks';
import { useAppContext } from '../../context/AppContext';

const appChirpFetch = createChirpFetch({
  loadBalancer: loadBalancers.APP,
  gateway: chirpGateways.APP,
});

const publicChirpFetch = createChirpFetch({
  loadBalancer: loadBalancers.APP,
  gateway: chirpGateways.EXTERNAL,
});

const appUserInsightsClient = createRpcClientV2({
  hubHttpClient: http,
  fetchClient: appChirpFetch,
});

const publicUserInsightsClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
  fetchClient: publicChirpFetch,
});

export function useUserInsightsClient() {
  const appContext = useAppContext();

  const result = useGetUserInsightsQuery({
    context: {
      customClient:
        appContext === 'app' ? appUserInsightsClient : publicUserInsightsClient,
    },
  });

  return { data: result.data, loading: result.loading };
}
